import { render, staticRenderFns } from "./Tipo_aprobacion.vue?vue&type=template&id=7c7e5d4c"
import script from "./Tipo_aprobacion.vue?vue&type=script&lang=js"
export * from "./Tipo_aprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports